import React from 'react';
import { format, addDays, subDays, startOfDay } from 'date-fns';

const DateNavigator = ({ 
  currentDate, 
  onDateChange, 
  isDateDisabled,
  minDate,
  maxDate 
}) => {
  // Debug log the received date
  console.log('DateNavigator received:', {
    localDate: currentDate.toLocaleString(),
    isoString: currentDate.toISOString(),
    date: currentDate.getDate(),
    month: currentDate.getMonth() + 1,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  });

  const handlePrevDay = () => {
    const prevDate = startOfDay(subDays(currentDate, 1));
    console.log('Previous date:', prevDate.toLocaleString());
    if (!isDateDisabled(prevDate)) {
      onDateChange(prevDate);
    }
  };

  const handleNextDay = () => {
    const nextDate = startOfDay(addDays(currentDate, 1));
    console.log('Next date:', nextDate.toLocaleString());
    if (!isDateDisabled(nextDate)) {
      onDateChange(nextDate);
    }
  };

  // Check if prev/next buttons should be disabled
  const isPrevDisabled = isDateDisabled(startOfDay(subDays(currentDate, 1)));
  const isNextDisabled = isDateDisabled(startOfDay(addDays(currentDate, 1)));

  return (
    <div className="max-w-[1200px] mx-auto px-4">
      <div className="w-full bg-black rounded-b-lg">
        <div className="py-2 flex items-center justify-center">
          <div className="flex items-center space-x-2">
            <button 
              onClick={handlePrevDay}
              disabled={isPrevDisabled}
              className={`text-2xl text-white transition-colors ${
                isPrevDisabled 
                  ? 'text-gray-600 cursor-not-allowed' 
                  : 'hover:text-gray-300'
              }`}
              aria-label="Previous day"
              title={isPrevDisabled ? `Cannot navigate before ${format(minDate, 'MMMM d, yyyy')}` : "Previous day"}
            >
              ←
            </button>
            
            <div className="text-lg text-white font-medium mx-2">
              {format(currentDate, 'MMMM d, yyyy')}
            </div>
            
            <button 
              onClick={handleNextDay}
              disabled={isNextDisabled}
              className={`text-2xl text-white transition-colors ${
                isNextDisabled 
                  ? 'text-gray-600 cursor-not-allowed' 
                  : 'hover:text-gray-300'
              }`}
              aria-label="Next day"
              title={isNextDisabled ? `Cannot navigate after ${format(maxDate, 'MMMM d, yyyy')}` : "Next day"}
            >
              →
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DateNavigator;